var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSocialGr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_in") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "983fd94a-70b9-47e7-a7ba-f41ee97e58d0",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "869fc78a-6d76-4490-8152-472096720448",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "48e156eb-4669-468b-a1b8-11555cf6ea46",
    "data-name": "e32658b5-0de2-4ac7-9d57-3c817baf400a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.23,0H7.81A7.81,7.81,0,0,0,0,7.81H0v9.41A7.81,7.81,0,0,0,7.81,25h9.41A7.81,7.81,0,0,0,25,17.23V7.81A7.81,7.81,0,0,0,17.23,0ZM22.7,17.23a5.47,5.47,0,0,1-5.47,5.47H7.81a5.47,5.47,0,0,1-5.47-5.47V7.81A5.47,5.47,0,0,1,7.81,2.34h9.41A5.47,5.47,0,0,1,22.7,7.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.49,6.25a6.25,6.25,0,1,0,6.25,6.25h0A6.25,6.25,0,0,0,12.49,6.25Zm0,10.13a3.9,3.9,0,1,1,3.9-3.9,3.9,3.9,0,0,1-3.9,3.9h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.21,
    cy: 5.78,
    r: 0.83,
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialGr);
export default __webpack_public_path__ + "static/media/icon-social-gr.8a9f73cbc0bae6c9b6ee246237824fe8.svg";
export { ForwardRef as ReactComponent };